<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import InputBox from '../../components/InputBox.vue';
import SolutoButton from '../../components/SolutoButton.vue';
import { mapActions, mapGetters } from 'vuex';

// This is Q20 is used only for call survey.
export default defineComponent({
  name: 'SurveyQ20',
  components: {
    InputBox,
    Button: SolutoButton
  },
  computed: {
    ...mapGetters([
      'deviceSupportFeedbackRequest'
    ])
  },
  methods: {
    ...mapActions([
      'changeDeviceSupportFeedbackRequest'
    ]),
    saveText (event: string) {
      this.changeDeviceSupportFeedbackRequest(event);
    },
    nextScreen () {
      router.push({ path: '/survey/end/' });
    },
    goBack () {
      router.go(-1);
    }
  }
});
</script>

<template>
  <div class="mainSurvey">
    <div class="q2">
        <p class="with-margin">{{ $t('survey_20') }}</p>
        <input-box @change="saveText" :text="deviceSupportFeedbackRequest"/>
    </div>
    <div class="mainSurvey-footer">
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('previous')"
        :type="'outlined'"
        @click="goBack()"
      />
      <Button
        class="footer-button"
        :size="'large'"
        :text="$t('next')"
        @click="nextScreen()"
      />
    </div>
  </div>
</template>
